import React, { useMemo } from 'react'

import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import ActionsRow from '../../../Components/antd/Lists/ActionsRow'
import { selectUser } from '../../../reducers/UserReducer'
import useInternship from '../../../utils/api/hooks/useInternship'
import { Action, DeleteAction, getActionsClass } from '../../../Components/antd/Tables/DataTable/utils/actions'
import { faFile } from '@fortawesome/pro-solid-svg-icons'
import { ActionTypes } from 'redux-devtools'
import { ColorsPalette } from '../../../config/colors'
import { isNonEmptyArray } from '../../../utils'
import { InternshipStates } from '../../../utils/constants'
import useModules from '../../../hooks/useModules'
import { canDeleteInternship } from '../../../utils/entities/internship'

const { PENDING } = InternshipStates

const InternshipToolBar = ({ internships = [], isDraft, onChange, onUnselect }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const internshipHandler = useInternship({ callback: onChange })
  const modules = useModules()

  const actions = useMemo(() => {
    const enabledActions = {
      publish: isNonEmptyArray(internships) && !internships.some(i => i.state > PENDING),
      delete: canDeleteInternship(user, internships)
    }
    const actions = []

    if (modules.internshipsDraft) {
      actions.push(new Action({
        title: t('internship_toolbar.buttons.' + (isDraft ? 'publish' : 'unpublish') + (enabledActions.publish ? '' : '_disabled')),
        className: getActionsClass,
        ghost: true,
        icon: faFile,
        type: ActionTypes.GLOBAL,
        color: enabledActions.publish ? ColorsPalette.BLUE_ICON : ColorsPalette.LIGHT_GREY,
        disabled: !enabledActions.publish,
        onClick: () => internshipHandler.bulkDraft(internships, !isDraft).then(() => onUnselect(true))
      }))
    }

    actions.push(new DeleteAction({
      title: 'internship_toolbar.buttons.delete',
      popconfirmTitle: 'internship_toolbar.buttons.delete',
      disabled: () => !enabledActions.delete,
      ghost: true,
      onDelete: () => internshipHandler.delete(internships).then(() => onUnselect(true))
    }))

    return actions
  }, [internshipHandler, internships, isDraft, modules, user, onUnselect])

  return (
    <div className='absolute left-50p z-500'>
      <ActionsRow
        actions={actions}
        buttonTitle={t('internship_toolbar.button_title', { numberOfInternships: internships.length })}
        buttonTooltipTitle={t('internship_toolbar.button_tooltip_title')}
        data={internships}
        onUnselect={onUnselect}
      />
    </div>
  )
}

export default InternshipToolBar
